import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListWorkEnvironments } from "../../../components/Admin/WorkEnvironments/ListWorkEnvironments/ListWorkEnvironments";
import { useLanguage } from "../../../contexts";
import "./WorkEnvironments.scss";

export function WorkEnvironments() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    { menuItem: t("actives"),   render: () => <Tab.Pane attached={false}><ListWorkEnvironments active={true}  reload={reload} onReload={onReload} /></Tab.Pane> },
    { menuItem: t("inactives"), render: () => <Tab.Pane attached={false}><ListWorkEnvironments active={false} reload={reload} onReload={onReload} /></Tab.Pane> },
  ];

  return (
    <div className="work-environments-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="work-environments-page-header-wrapper">
        <div className="work-environments-page-header">
          <span className="work-environments-page-title">{t("work_environments")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
